import { render, staticRenderFns } from "./specialtys.vue?vue&type=template&id=ed0312d0"
import script from "./specialtys.vue?vue&type=script&lang=js"
export * from "./specialtys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports